const state = { 
    selectedFolder : [],
  };
  const actions = {};
  const mutations = { 
    setSelectedFolder (state, payload){  
      state.selectedFolder = payload;
    }
  };
  const getters = {};
  
  export default { state, actions, mutations, getters, namespaced: true };
  


// WEBPACK FOOTER //
// ./src/js/store/module/private/private.js